export default {
    resumPendignAdm: 0,
    resumStatusAssign: {"canceleds":0,"running":0,"closed":0,"expired": 0},
    dataGrafic: {},
    filtersHome: {last_days: 'all', sistems: 'all'},
    loadChart: false,
}